import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoaderComponent } from './loader.component';
import { LoaderModule as KendoLoaderModule } from '@progress/kendo-angular-indicators';


@NgModule({
  declarations: [LoaderComponent],
  imports: [
    CommonModule,
    KendoLoaderModule
  ],
  exports: [LoaderComponent],
})
export class LoaderModule {}
